export function parseParamToObj(obj) {
  if (!obj) {
    return;
  }
  let str = obj.search;
  if (!str) {
    str = obj.hash;
  }
  const index = str.indexOf("?");
  str = str.substring(index + 1);
  const result = {};
  const paramArray = str.split("&");
  for (let i = 0, len = paramArray.length; i < len; i++) {
    const pair = paramArray[i].split("=");
    if (pair[1] === "") {
      pair.push("");
    }
    result[pair[0]] = pair[1];
  }
  return result;
}
